import type { PlayerData } from '../PlayersStats.types';

import PlayerInfo from './PlayerInfo';
import PlayerSingleStat from './PlayerStat/PlayerSingleStat';

interface PlayerStatGoalRowProps {
  playerData: PlayerData;
}

export default function PlayerStatGoalRow({ playerData }: PlayerStatGoalRowProps) {
  return (
    <div className="col-span-5 grid grid-cols-subgrid min-h-[40px]">
      <PlayerInfo
        name={playerData.name}
        position={playerData.position}
        jerseySrc={playerData.jerseySrc}
        flagSrc={playerData.flagSrc}
      />
      <PlayerSingleStat
        className="col-start-[stat-1]"
        statValue={playerData.goals || 0}
        isHome={playerData.isHome}
      />
    </div>
  );
}
